import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { MdPeopleOutline } from "react-icons/md";
import { FaDollarSign } from "react-icons/fa";
import CustomButton from "../../components/CustomButton";
import LeaveGameModal from "../../components/LeaveGame";
import { apiHandler } from "../../assets/api";
import { endpoint } from "../../assets/api/endpoint";
import "../../assets/css/ApproveOrDenyRequest.css";
import "../../assets/css/Custom.css";
import message from '../../assets/images/messages.png';
import GoogleMapComponent from "../../components/GoogleMap";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import PaymentModal from "../../components/PaymentModal";
import { RxCross2 } from "react-icons/rx";
import boyImage from '../../assets/images/boy.png';
import { useDispatch } from "react-redux";
import { saveParticipantsUser } from "../../redux/UserDataSlice";
import { IoIosArrowDropleft } from "react-icons/io";
import { HashLoader } from 'react-spinners';
import { IoLocationOutline } from "react-icons/io5";
import Boy from '../../assets/icons/B.png';
import Girl from '../../assets/icons/G.png';
import { useGameSocket } from "../gamelist/GameSocketListener";



const MyGameJoined = () => {
  const { gameId } = useParams();
  const navigate = useNavigate();
  const { accessToken, saveCardDetailData, sportDetailConfig, profileData, userInfo } = useSelector((state) => state.loginInfo);
  const [gameDetails, setGameDetails] = useState(null);
  const [leaveGame, setLeaveGame] = useState(false);
  const [isModalVisible, setModalVisible] = useState(true);
  const [courtData, setCourtData] = useState([{}]);
  const [formData, setFormData] = useState();
  const [errors, setErrors] = useState();
  const location = useLocation();
  const isRequested = location.state?.isRequested;
  const isWaitingPlayer = location.state?.isWaitingPlayer;
  const NotShowchat = location.state?.NotShowchat;
  const hostName = location.state?.hostName;
  const sportNames = location?.state?.sportNames
  const [isOpen, setIsOpen] = useState(false);
  const [selectedGameId, setSelectedGameId] = useState();
  const dispatch = useDispatch();
  //  const { socketGame } = useGameSocket();

  useEffect(() => {
    const fetchGames = async () => {
      try {
        const result = await apiHandler({
          url: `${endpoint.GAME_DETAIL}?gameId=${gameId}`,
          method: "GET",
          authToken: accessToken?.accessToken,
        });
        setCourtData([{ longitude: result.data.coordinates.longitude, latitude: result.data.coordinates.latitude, courtName: result.data.courtName }])
        setGameDetails(result.data);

      } catch (error) {
        console.error("Error fetching game details:", error);
      }
    };
    fetchGames();
  }, [gameId, accessToken]);
  // socketGame

  const onGameDetails = () => {
    setLeaveGame(true);
  };

  if (!gameDetails) {
    return <div className="d-flex align-items-center justify-content-center" style={{ height: '75vh' }}>
      < HashLoader color="#e48181" />
    </div>
  }
  if (!isModalVisible) return null;

  const {
    gameName,
    sportName,
    // hostName,
    courtName,
    level,
    status,
    startTime,
    endTime,
    courtPrice,
    participants,
    currentPlayers,
    requiredPlayers,
  } = gameDetails;

  const handleCloseModal = () => {
    setModalVisible(false);
  };

  const onGoToBackPage = () => {
    navigate(-1);
  }

  const formatDateTime = (startTime, endTime) => {
    const months = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN",
      "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];

    const parseDateTime = (dateTimeStr) => {
      const [datePart, timePart] = dateTimeStr.split(" ");
      const [day, month, year] = datePart.split("-").map(Number);
      const [hour, min] = timePart.split(":").map(Number);
      return {
        date: new Date(year, month - 1, day, hour, min),
        hour,
        min,
        day,
        month,
      };
    };

    const start = parseDateTime(startTime);
    const end = parseDateTime(endTime);

    const formattedDate = `${start.day} ${months[start.month - 1]}`;
    const formattedStart = `${String(start.hour).padStart(2, "0")}:${String(start.min).padStart(2, "0")}`;
    const formattedEnd = `${String(end.hour).padStart(2, "0")}:${String(end.min).padStart(2, "0")}`;

    return `${formattedDate}, ${formattedStart} - ${formattedEnd}`;
  };

  const handleCourtSelectFromMap = (court) => {
    setFormData((prev) => ({
      ...prev,
      courtName: court?.courtName
    }));

    if (errors?.courtName) {
      setErrors({
        ...errors,
        courtName: ""
      });
    }
  };

  const toggleModal = () => {
    setIsOpen(!isOpen);
  };

  const onRequestJoined = async () => {
    setSelectedGameId(gameId);
    if (saveCardDetailData?.userConfgis?.isEligibleForService) {
      const payload = {
        gameId: gameId,
        paymentIntentId: null,
        transactionId: null
      }
      try {
        const result = await apiHandler({
          url: `${endpoint?.GAME_REQUESTED_TO_JOIN}`,
          method: "POST",
          data: payload,
          authToken: accessToken?.accessToken,
        });
        if (result?.data?.code !== '500' && !(result?.data?.user_description == 'An unexpected error occurred')) {
          toast.success("Successfully joined the game!");
        }
        else {
          toast.error("Failed to join the game.");
        }
      } catch (error) {
        toast.error("Failed to join the game.");
      }
    } else {
      setIsOpen(true);
    }
  };

  const aboutGameInfo = [
    { title: "Court Name", subTitle: gameDetails.courtName },
    { title: "Host Name", subTitle: gameDetails.hostName },
    {
      title: "Description", subTitle: gameDetails.gameDescription
    },
  ];

  const onPrivateChat = async (item) => {
    try {
      const response = await apiHandler({
        url: `${endpoint?.HANDLE_PRIVATE_CHAT}/${item?.userId}`,
        method: 'POST',
        authToken: accessToken?.accessToken,
      });

      dispatch(saveParticipantsUser(item));
      navigate("/chat", {
        state: {
          isJoinedPage: true,
          chatType: "PRIVATE",
          ChatId: response?.data?.chatId,
        },
      });

    } catch (error) {
      console.error("Private chat error:", error);
    }
  };

  const getSportIcon = (sportName) => {
    const sport = sportDetailConfig?.find(
      (item) => item.sportName?.toLowerCase() === sportName?.toLowerCase()
    );
    return `${endpoint.BASE_URL_STAGING}/public/images/${sport?.icon}`
  };

  return (
    <>
      <div className="container p-3 p-sm-0">
        <div className="row  mt-0 mt-sm-3 mb-0 mb-sm-3">
          <div className="d-flex justify-content-start" >
            <CustomButton
              className="back-page-btn"
              onClick={onGoToBackPage}
              buttonText={
                <> <IoIosArrowDropleft className="me-3" style={{ cursor: 'pointer', fontSize: '31px' }} /> Back</>
              }
            />
          </div>
          <div className="col-lg-6 mb-3 p-3 p-sm-4" style={{ boxShadow: 'rgba(96, 97, 112, 0.16) 0px 2px 4px 0px', borderRadius: '10px', background: 'white' }}>
            <div className="d-flex justify-content-between py-2">
              <div className="game-txt  fs-4" style={{ fontWeight: '600' }}>
                <img src={getSportIcon(sportNames)} className="game-card-ball-icon" alt="Game Icon" />
                {gameName}
              </div>
              <div>
                <span className={`approve-circle-${status?.toLowerCase()}`}></span>
                <span className="active-txt">{status}</span>
              </div>
            </div>

            <div className="d-flex justify-content-between mt-3 mb-4">
              <CustomButton buttonText={level || "Level"} className="custom-beginer-button approve-or-deny-beginner px text-upper" />
              <CustomButton buttonText={sportName || "Sport"} className="custom-beginer-button approve-or-deny-beginner text-upper" />
            </div>

            <div>
              <div className="game-info-txt fs-5" style={{ color: '#71727A' }}>Game Information</div>
              <div className="row mt-3 game-information-wrapper">
                {[
                  {
                    icon: <MdPeopleOutline style={{ color: "#006FFD" }} />,
                    text: `${currentPlayers} out of ${requiredPlayers} players`,
                  },
                  {
                    icon: <IoLocationOutline style={{ color: "#006FFD" }} />,
                    text: courtName,
                  },
                  {
                    icon: <MdPeopleOutline style={{ color: "#006FFD" }} />,
                    text: `${requiredPlayers} players`,
                  },
                  {
                    icon: <FaDollarSign style={{ color: "#006FFD" }} />,
                    text: ` ${courtPrice == null || 0 || '0 ' ? 'Free' : courtPrice + ' per player'} `,
                  },
                ].map((item, index) => (
                  <div className="col-6 co-sm-6 col-lg-6 col-md-6" key={index}>
                    <div className="d-flex align-items-center pb-3">
                      {item?.icon}
                      <div className="approve-or-deny-game-info-txt">{item?.text}</div>
                    </div>
                  </div>
                ))}
              </div>
              <div className="mt-2 approve-or-deny-title">Date and Time: <span style={{ fontSize: '14px', color: '#71727A' }}>{formatDateTime(startTime, endTime)} </span></div>
            </div>

            <div className="row mt-4">
              {aboutGameInfo?.map((item, index) => (
                <div className={`col-6 col-sm-4 col-md-6 ${aboutGameInfo.length === 1 || (aboutGameInfo.length % 2 !== 0 && index === aboutGameInfo.length - 1) ? "col-lg-12" : ""} `} key={index}>
                  <div className="">
                    <h3 className="approve-or-deny-title">{item.title}</h3>
                    <p className="approve-or-deny-subtitle ">{item.subTitle}</p>
                  </div>
                </div>
              ))}
            </div>

          </div>

          <div className="col-lg-6">
            <div className=" p-2 p-sm-4" style={{ boxShadow: 'rgba(96, 97, 112, 0.16) 0px 2px 4px 0px', borderRadius: '10px', background: 'white' }}>
              <GoogleMapComponent height={'250px'} courtData={courtData} onCourtSelect={handleCourtSelectFromMap} />
            </div>
            <div className=" p-2 p-sm-4" style={{ boxShadow: 'rgba(96, 97, 112, 0.16) 0px 2px 4px 0px', borderRadius: '10px', marginTop: '15px', background: 'white' }}>
              <div className="mt-0 mt-sm-4 " >
                <div className="ps-2">
                  <span className="approve-or-deny-game-info-txt"><span className=" fs-5" style={{ fontWeight: '600' }}> Participants: </span> {participants.length} OUT OF {requiredPlayers}</span>
                </div>
                <div className="row">
                  {participants?.map((participant, index) => (
                    <>
                      <div className="col-md-12 col-lg-12 mb-3 d-flex align-items-center justify-content-between px-sm-0 participant-wrapper px-3 " key={index}   >
                        <div className="d-flex align-items-center p-3">
                          <div className="d-flex flex-column">
                            <img src={participant?.avatarUrl || boyImage} alt={participant?.name} width="50" height="50" />
                            <div style={{ color: '#71727A', fontSize: '12px' }}> {participant?.avatarName} </div>
                          </div>
                          <div style={{ height: '66px', marginLeft: '10px', width: '10px', backgroundColor: '#e9ecef', borderRadius: '0px', overflow: 'hidden' }}>
                            <div
                              style={{
                                height: `${participant?.reliability}%`,
                                width: '100%',
                                backgroundColor: 'green',
                                transition: 'height 0.3s ease',
                              }}
                            ></div>
                          </div>
                        <div className="d-block d-sm-flex">
                          <div className="ml-3">
                            <span className="text-primary px-2 fw-semibold d-block">{participant.name}</span>
                          </div>
                          <div className="d-flex ms-2 ms-sm-0">
                            <img src={participant?.gender == "MALE" ? Boy : Girl} width='20px' height='20px' />
                            <div className="skill-level">{participant?.skillLevel && `(${participant?.skillLevel})`}</div>
                          </div>
                          </div>
                        </div>

                        {(profileData?.baseProfile?.name?.toLowerCase() !== participant.name?.toLowerCase())   &&
                          <div className="d-flex justify-content-between" style={{ width: "8%" }}>
                           { ( NotShowchat == undefined) &&
                            <img src={message} onClick={() => onPrivateChat(participant)} style={{ cursor: 'pointer' }} />
                           }
                          </div>
                        }
                      </div>
                    </>
                  ))}
                </div>
                <div>

                  {

                    (isRequested != null && isWaitingPlayer != null) ?
                      <CustomButton
                        buttonText={"Requested To Join"}
                        className="border requested-to-join w-100"
                        disabled={(isWaitingPlayer == true || (isRequested == true && isWaitingPlayer !== true))
                        }
                        onClick={onRequestJoined}
                      />

                      :

                      <CustomButton
                        buttonText={"Leave The Game"}
                        className="border leave-the-game-btn"
                        onClick={onGameDetails}
                        disabled={profileData?.baseProfile?.name?.toLowerCase() == hostName?.toLowerCase()}
                      />

                  }
                </div>
              </div>
            </div>
          </div>

          {leaveGame && <LeaveGameModal onClose={handleCloseModal} />}
        </div>

      </div>
      {isOpen && (
        <div className="modal-overlay open">
          <div className="modal-content" style={{ width: "100%", height: "500px", overflow: 'auto' }}>
            <button onClick={toggleModal} className="close-button">
              <RxCross2 className="fs-4" />
            </button>
            <PaymentModal PaymentWay={"joinedGame"} gameId={selectedGameId} />
          </div>
        </div>
      )}
    </>
  );
};

export default MyGameJoined;
